import {ReactElement, ReactNode, JSXElementConstructor} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {Dialog, DialogContent, Fade, IconButton} from '@mui/material';
import {TransitionProps} from '@mui/material/transitions';
import useModal from '@/shared/hooks/useModal';

export default function AlertModal({
  children,
  Transition = Fade,
  onClose,
  id
}: {
  id?: string;
  Transition?: JSXElementConstructor<TransitionProps & {children: ReactElement<any, any>}> | null;
  children: ReactNode;
  onClose?: () => void;
}) {
  const modal = useModal(true);

  function handleClose() {
    modal.close();
    onClose?.();
  }
  return (
    <Dialog
      TransitionComponent={Transition ?? undefined}
      open={modal.isOpened}
      scroll="body"
      onClose={handleClose}
      id={id}
    >
      <DialogContent dividers sx={{position: 'relative', p: 2, border: 0}}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'grey.500'
          }}
        >
          <CloseIcon />
        </IconButton>
        {children}
      </DialogContent>
    </Dialog>
  );
}
